module.exports = __webpack_public_path__ + "media/images/lb/718-a0fc3ab4354539be927dcba23c65c2e0.svg";